import { render } from "./PageLoader.vue?vue&type=template&id=7ec62548&scoped=true"
const script = {}

import "./PageLoader.vue?vue&type=style&index=0&id=7ec62548&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ec62548"]])

export default __exports__